/**
 * Determines if a string is an email address as opposed to an address domain
 * @param text - contains either a valid email address or a valid address domain
 */
export default function isEmailAddress(text) {
    return text.indexOf('@') !== -1;
}
//# sourceMappingURL=isEmailAddress.js.map